module.exports = __webpack_public_path__ + "img/2025gyx-2.1bad5689.jpeg";